import { css } from 'styled-components'

export default () => css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
